<template>
  <div
    class="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden hover:shadow-md transition-shadow cursor-pointer"
    @click="$emit('open')"
  >
    <!-- Community badge -->
    <div v-if="announcement.communities && announcement.communities.length > 0" class="mt-2 ml-2 absolute z-10">
      <span class="inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full bg-blue-50 text-primary">
        <svg class="h-3 w-3 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
        </svg>
        {{ announcement.communities[0].label }}
      </span>
    </div>

    <!-- Image -->
    <div v-if="getImageForAnnouncement(announcement)" class="h-40 overflow-hidden bg-gray-100">
      <img
        :src="getImageForAnnouncement(announcement)"
        :alt="announcement.title"
        class="w-full h-full object-cover"
        @error="$event.target.style.display='none'"
      />
    </div>

    <div class="p-4">
      <!-- Author -->
      <div class="tw-flex items-center gap-2 mb-3">
        <AvatarNew
          showDetails
          showClaim
          v-if="announcement.user && announcement.user.photo_url"
          :user="announcement.user"
        />
      </div>

      <!-- Title + description -->
      <h4 class="text-sm font-semibold text-gray-900 leading-snug line-clamp-2">{{ announcement.title }}</h4>
      <p class="mt-1 text-xs text-gray-500 line-clamp-2 leading-relaxed" v-html="announcement.shortDescription"/>

      <!-- Engagement bar -->
      <div class="mt-3 pt-3 border-t border-gray-100 tw-flex items-center gap-4">
        <!-- Like -->
        <button
          class="tw-flex items-center gap-1.5 text-xs border-0 bg-transparent p-0 cursor-pointer transition-colors"
          :class="liked ? 'text-red-500' : 'text-gray-500 hover:text-red-400'"
          @click.stop="toggleLike"
        >
          <svg class="h-4 w-4 transition-all" :fill="liked ? 'currentColor' : 'none'" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>
          </svg>
          <span>{{ likeCount }} {{ $t('personal_home_likes') }}</span>
        </button>

        <!-- Comments -->
        <button
          class="tw-flex items-center gap-1.5 text-xs text-gray-500 hover:text-primary border-0 bg-transparent p-0 cursor-pointer transition-colors"
          @click.stop="$emit('open')"
        >
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>
          </svg>
          <span>{{ announcement.comments || 0 }} {{ $t('personal_home_comments') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { getImageForAnnouncement } from '@/util/helpers'
  import AvatarNew from '@/components/Avatar/AvatarNew.vue'
  import { toggleLike } from '@/Domain/Announcements/Api/notifications'

  export default {
    name: 'PersonalHomeAnnouncementCard',
    components: { AvatarNew },
    props: {
      announcement: {
        type: Object,
        required: true,
      },
    },
    emits: ['open'],
    data () {
      return {
        liked: !!this.announcement.user_like,
        likeCount: this.announcement.likers ? this.announcement.likers.length : 0,
      }
    },
    methods: {
      getImageForAnnouncement,
      async toggleLike () {
        const newLiked = !this.liked
        this.liked = newLiked
        this.likeCount += newLiked ? 1 : -1
        try {
          await toggleLike(this.announcement.id)
        } catch {
          // Revert on failure
          this.liked = !newLiked
          this.likeCount += newLiked ? -1 : 1
        }
      },
    },
  }
</script>
